export default __webpack_public_path__ + "b4d519bbfd9429eadc54d4159d27b948.svg";